"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUNDNESS = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _image = _interopRequireDefault(require("next/image"));
var _core = require("@commerce-ui/core2");
var _blurhash = require("blurhash");
var _arrayToImage = require("array-to-image");
var _generateBlurUrl = _interopRequireDefault(require("@deosite/helpers/generateBlurUrl"));
var _Image = _interopRequireDefault(require("@deosite/ui-entities/Image"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var addCloudflareToUrl = function addCloudflareToUrl(url, width, quality, cloudflareEnabled) {
  var imgQuality = quality ? "quality=" + quality + "," : "";
  if (url.includes("$width")) {
    var newUrl = url.replace(/^https?:\/\/[^#?\/]+/, "");
    return "https://".concat(global.__appConfig__.imageServer).concat(newUrl.replace(/\$width/, width));
  }
  return url.indexOf("static/") > 0 ? url : isCloudflareDisabled(cloudflareEnabled) ? "".concat(global.__appConfig__.dajarmediaImgUrl).concat(url.replace(/^https?:\/\/[^#?\/]+/, "")) : "".concat(global.__appConfig__.cloudflareImgUrl, "width=").concat(width, ",") + imgQuality + "format=auto".concat(url.replace(/^https?:\/\/[^#?\/]+/, ""));
};
var isCloudflareDisabled = function isCloudflareDisabled(cloudflareEnabled) {
  return parseInt(global.__appConfig__.cloudflareForceDisable) ? global.__appConfig__.cloudflareForceDisable : cloudflareEnabled === undefined || !parseInt(cloudflareEnabled);
};
var findVariant = function findVariant(image, variant) {
  return image.variants.find(function (v) {
    return v.name === variant;
  });
};
var ROUNDNESS = {
  soft: "15px",
  medium: "25px",
  hard: "30px",
  none: "0px"
};
exports.ROUNDNESS = ROUNDNESS;
Object.freeze(ROUNDNESS);
var defaultProps = {
  overlay: false,
  roundness: ROUNDNESS.none,
  minified: false,
  borderSpace: "false",
  position: "center center",
  overlayOpacity: 0.03,
  overlayColor: "black",
  localImgSrc: false,
  borderWidth: 1,
  staticImage: false
};
var Image = function Image(props) {
  var _image$originalSrc, _sx$variant, _image$altText, _image$altText2;
  var _props$overlay = props.overlay,
    overlay = _props$overlay === void 0 ? defaultProps.overlay : _props$overlay,
    _props$overlayOpacity = props.overlayOpacity,
    overlayOpacity = _props$overlayOpacity === void 0 ? defaultProps.overlayOpacity : _props$overlayOpacity,
    _props$minified = props.minified,
    minified = _props$minified === void 0 ? defaultProps.minified : _props$minified,
    _props$roundness = props.roundness,
    roundness = _props$roundness === void 0 ? defaultProps.roundness : _props$roundness,
    _props$borderSpace = props.borderSpace,
    borderSpace = _props$borderSpace === void 0 ? defaultProps.borderSpace : _props$borderSpace,
    _props$borderWidth = props.borderWidth,
    borderWidth = _props$borderWidth === void 0 ? defaultProps.borderSpace : _props$borderWidth,
    _props$position = props.position,
    position = _props$position === void 0 ? defaultProps.position : _props$position,
    _props$overlayColor = props.overlayColor,
    overlayColor = _props$overlayColor === void 0 ? defaultProps.overlayColor : _props$overlayColor,
    image = props.image,
    cloudflareEnabled = props.cloudflareEnabled,
    sizes = props.sizes,
    quality = props.quality,
    sx = props.sx,
    priority = props.priority,
    mode = props.mode,
    highlighted = props.highlighted,
    selected = props.selected,
    additionalStyles = props.additionalStyles,
    borderColor = props.borderColor,
    children = props.children,
    _props$localImgSrc = props.localImgSrc,
    localImgSrc = _props$localImgSrc === void 0 ? defaultProps.localImgSrc : _props$localImgSrc;
  var _props$staticImage = props.staticImage,
    staticImage = _props$staticImage === void 0 ? defaultProps.staticImage : _props$staticImage;
  var isSvg = image === null || image === void 0 ? void 0 : (_image$originalSrc = image.originalSrc) === null || _image$originalSrc === void 0 ? void 0 : _image$originalSrc.includes(".svg", -4);
  staticImage = staticImage && !isSvg;
  var blurUrl, imageWidth, imageHeight;
  if (global.__appConfig__.imageBlurhash && image !== null && image !== void 0 && image.blurhash) {
    var pixels;
    var widthImageBlur = 32,
      heightImageBlur = 32;
    var imageString = image.blurhash;
    pixels = (0, _blurhash.decode)(imageString, widthImageBlur, heightImageBlur);
    if (process.browser) {
      var imageBlur = (0, _arrayToImage.getImgFromArr)(pixels, widthImageBlur, heightImageBlur);
      blurUrl = imageBlur.src;
    } else {
      var _imageBlur = (0, _generateBlurUrl["default"])(pixels, widthImageBlur, heightImageBlur);
      blurUrl = _imageBlur;
    }
  }
  var $aspectRatio = sx === null || sx === void 0 ? void 0 : sx.aspectRatio;
  var variant = (_sx$variant = sx === null || sx === void 0 ? void 0 : sx.variant) !== null && _sx$variant !== void 0 ? _sx$variant : ["natural"];
  var paddingBottom = $aspectRatio ? (0, _core.responsiveValueMap)($aspectRatio, function (x) {
    return "".concat(x * 100, "%");
  }) : (0, _core.responsiveValueMap)(variant, function (variantName) {
    var _findVariant;
    return "".concat(1 / ((_findVariant = findVariant(image, variantName)) === null || _findVariant === void 0 ? void 0 : _findVariant.aspectRatio) * 100, "%");
  });
  if (!(image !== null && image !== void 0 && image.originalSrc)) {
    return null;
  }
  var originalSrc = image.originalSrc;
  if ((sx === null || sx === void 0 ? void 0 : sx.variant) === "mobile") {
    var _image$variants$find$, _image$variants$find, _image$variants$find$2, _image$variants$find$3;
    originalSrc = (_image$variants$find$ = (_image$variants$find = image.variants.find(function (variant) {
      return variant.name === "mobile";
    })) === null || _image$variants$find === void 0 ? void 0 : (_image$variants$find$2 = _image$variants$find.srcset) === null || _image$variants$find$2 === void 0 ? void 0 : (_image$variants$find$3 = _image$variants$find$2[0]) === null || _image$variants$find$3 === void 0 ? void 0 : _image$variants$find$3.url) !== null && _image$variants$find$ !== void 0 ? _image$variants$find$ : image === null || image === void 0 ? void 0 : image.originalSrc;
  }
  var isFromPrismic = image.originalSrc.split("/")[2] === global.__appConfig__.prismicMediaDomain;
  var myLoader = function myLoader(_ref) {
    var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
    if (isFromPrismic || isSvg) {
      var _isMobileImg;
      src = (_isMobileImg = isMobileImg(width)) !== null && _isMobileImg !== void 0 ? _isMobileImg : src;
      if (!isSvg && !src.match(/w=[0-9]*&h=[0-9]*/)) {
        var _image$variants, _image$variants$0$src2;
        var _image$variants$0$src = (_image$variants = image.variants) === null || _image$variants === void 0 ? void 0 : (_image$variants$0$src2 = _image$variants[0].srcset) === null || _image$variants$0$src2 === void 0 ? void 0 : _image$variants$0$src2[0],
          w = _image$variants$0$src.w,
          h = _image$variants$0$src.h;
        src += "&rect=0,0,".concat(w, ",").concat(h, "&w=").concat(width);
      } else {
        src = src.replace(/w=[0-9]*&h=[0-9]*/, "w=".concat(width));
      }
    } else {
      src = localImgSrc ? src : addCloudflareToUrl(src, width, quality, cloudflareEnabled, blurUrl);
    }
    return src;
  };
  var isMobileImg = function isMobileImg(width) {
    var _sx$variant2, _sx$variant3;
    if (sx !== null && sx !== void 0 && (_sx$variant2 = sx.variant) !== null && _sx$variant2 !== void 0 && _sx$variant2.includes("mobile") && variant.includes("mobile") && width < 961) {
      var _image$variants$find2, _image$variants$find3, _image$variants$find4;
      return (_image$variants$find2 = image.variants.find(function (variant) {
        return variant.name === "mobile";
      })) === null || _image$variants$find2 === void 0 ? void 0 : (_image$variants$find3 = _image$variants$find2.srcset) === null || _image$variants$find3 === void 0 ? void 0 : (_image$variants$find4 = _image$variants$find3[0]) === null || _image$variants$find4 === void 0 ? void 0 : _image$variants$find4.url;
    } else if (sx !== null && sx !== void 0 && (_sx$variant3 = sx.variant) !== null && _sx$variant3 !== void 0 && _sx$variant3.includes("mobilesecond") && variant.includes("mobilesecond") && width < 961) {
      var _image$variants$find5, _image$variants$find6, _image$variants$find7;
      return (_image$variants$find5 = image.variants.find(function (variant) {
        return variant.name === "mobilesecond";
      })) === null || _image$variants$find5 === void 0 ? void 0 : (_image$variants$find6 = _image$variants$find5.srcset) === null || _image$variants$find6 === void 0 ? void 0 : (_image$variants$find7 = _image$variants$find6[0]) === null || _image$variants$find7 === void 0 ? void 0 : _image$variants$find7.url;
    }
  };
  if (staticImage) {
    var _image$variants$find8, _image$variants$find9;
    var currentImage = (_image$variants$find8 = image.variants.find(function (variant) {
      return variant.name === (isMobileImg(960) ? "mobile" : "natural");
    })) === null || _image$variants$find8 === void 0 ? void 0 : (_image$variants$find9 = _image$variants$find8.srcset) === null || _image$variants$find9 === void 0 ? void 0 : _image$variants$find9[0];
    imageWidth = currentImage.w;
    imageHeight = currentImage.h;
    originalSrc = currentImage.url;
  }
  return staticImage ? __jsx(_image["default"], {
    src: originalSrc,
    loader: myLoader,
    sizes: "100vw",
    blurDataURL: blurUrl,
    style: {
      width: "100%",
      height: "auto"
    },
    width: imageWidth,
    height: imageHeight
  }) : minified ? __jsx(_Box["default"], {
    sx: {
      width: "100%",
      height: "100%",
      img: _objectSpread(_objectSpread({}, additionalStyles), {}, {
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        objectFit: "contain",
        objectPosition: "center center",
        display: "block",
        margin: "auto",
        borderColor: borderColor !== null && borderColor !== void 0 ? borderColor : "black",
        borderStyle: "solid",
        boxSizing: "border-box",
        borderWidth: highlighted || selected ? "".concat(borderWidth, "px") : 0,
        borderRadius: roundness,
        padding: borderSpace ? "3px" : 0,
        background: highlighted || selected ? "white" : "none"
      })
    }
  }, __jsx("img", {
    src: myLoader({
      src: originalSrc,
      width: 100,
      quality: quality
    }),
    alt: image.altText
  })) : __jsx(_Box["default"], {
    sx: _objectSpread({
      position: "relative",
      borderRadius: roundness,
      overflow: "hidden"
    }, sx)
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      paddingBottom: paddingBottom
    }
  }), blurUrl ? __jsx(_image["default"], {
    sizes: sizes,
    loader: myLoader,
    src: originalSrc,
    alt: (_image$altText = image.altText) !== null && _image$altText !== void 0 ? _image$altText : "",
    layout: "fill",
    quality: quality !== null && quality !== void 0 ? quality : 70,
    objectPosition: position,
    objectFit: mode !== null && mode !== void 0 ? mode : "contain",
    placeholder: "blur",
    blurDataURL: blurUrl,
    priority: priority
  }) : __jsx(_image["default"], {
    sizes: sizes,
    loader: myLoader,
    src: originalSrc,
    alt: (_image$altText2 = image.altText) !== null && _image$altText2 !== void 0 ? _image$altText2 : "",
    layout: "fill",
    quality: quality !== null && quality !== void 0 ? quality : 70,
    objectPosition: position,
    objectFit: mode !== null && mode !== void 0 ? mode : "contain",
    priority: priority
  }), overlay && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      bg: overlayColor,
      opacity: overlayOpacity
    }
  }), children);
};
var _default = Image;
exports["default"] = _default;